package org.zq.astrock_ai.network

import kotlinx.browser.localStorage

actual fun moonshotApiKey(): String? =
    localStorage.getItem("MOONSHOT_API_KEY")
        ?.trim()
        ?.takeIf { it.isNotEmpty() }

actual fun moonshotModel(): String =
    localStorage.getItem("KIMI_MODEL")?.trim()?.takeIf { it.isNotEmpty() } ?: "kimi-k3"

actual fun moonshotReasoningEffort(): String =
    localStorage.getItem("KIMI_REASONING_EFFORT")?.trim()?.takeIf { it.isNotEmpty() } ?: "high"
